import { useQuery } from '@tanstack/react-query';
import { useInjection } from 'inversify-react';
import { AuthService, type IAuthService } from '../../../services/auth/auth.service';
import { profileQueryKeys } from '../query-keys';

export function useProfile(options?: { enabled?: boolean }) {
  const authService = useInjection<IAuthService>(AuthService);
  return useQuery({
    queryKey: profileQueryKeys.profile,
    queryFn: () => authService.getProfile(),
    enabled: options?.enabled,
  });
}
